import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

interface ToasterProps {
  show: boolean;
  type: 'success' | 'info' | 'warning' | 'error';
  text: string;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
}

const Alert = React.forwardRef < HTMLDivElement, AlertProps> (function Alert(props, ref) {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const Toaster: React.FC<ToasterProps> = ({ show, type, text, onClose }) => (
  <Snackbar
    open={show}
    autoHideDuration={3000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <Alert severity={type} onClose={onClose}>
      {text}
    </Alert>
  </Snackbar>
);

export default Toaster;
